import { getFeature } from 'Cloud/Application/FeaturesEs6';

const availableExstension = getFeature('download-as-jpeg') || [];

export const isAvailableUrl = (ext?: string): boolean => !!ext && availableExstension.includes(ext.toLowerCase());
